module.exports = __webpack_public_path__ + "static/NINDS-2325059f3df27dab9e64018c0e242e44.png";